/* eslint-disable import/prefer-default-export */
// Serve the local fixture while the backend (TBR-5906) is not available.
// Flip to false once GET /api3/importer/jobs is live.
export const USE_IMPORTER_MOCK = false;
